import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Inbox, Loader2, Play, Star, Trash2 } from 'lucide-react';
import { klarysUrl } from './klarysApi';

const fmt = (iso) => new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const KlarysPartages = ({ headers, onLancer, onVu }) => {
  const [items, setItems] = useState(null);
  const charger = () => axios.get(klarysUrl('/partages'), { headers }).then((r) => {
    setItems(r.data.items);
    r.data.items.filter((x) => !x.lu_at).forEach((x) => axios.post(klarysUrl(`/partages/${x.id}/lu`), {}, { headers }).catch(() => {}));
    onVu();
  }).catch(() => setItems([]));
  useEffect(() => { charger(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const lancer = async (p) => {
    await axios.post(klarysUrl(`/partages/${p.id}/lu`), { lance: true }, { headers }).catch(() => {});
    onLancer(p.texte, p.type === 'modele' ? p.titre : null);
  };
  const favori = async (p) => {
    try {
      await axios.post(klarysUrl(p.type === 'modele' ? '/modeles' : '/favoris'), { texte: p.texte, titre: p.titre }, { headers });
      toast.success(p.type === 'modele' ? 'Ajouté à mes modèles' : 'Ajoutée aux favoris');
    }
    catch (e) { toast.error(e.response?.data?.detail || 'Ajout impossible'); }
  };
  const supprimer = async (p) => {
    await axios.delete(klarysUrl(`/partages/${p.id}`), { headers }).catch(() => {});
    charger();
  };
  if (items === null) return <div className="p-6 text-center"><Loader2 className="inline h-5 w-5 animate-spin text-slate-400" /></div>;
  return (
    <div className="h-full overflow-y-auto bg-[#f6f8fb] p-4" data-testid="klarys-partages">
      {!items.length ? (
        <p className="flex flex-col items-center gap-2 py-10 text-sm text-slate-500" data-testid="klarys-partages-vide"><Inbox className="h-6 w-6" /> Aucune demande partagée avec vous.</p>
      ) : (
        <ul className="space-y-2">
          {items.map((p) => (
            <li key={p.id} className="rounded-xl border border-slate-200 bg-white p-3" data-testid={`klarys-partage-${p.id}`}>
              <p className="text-[11px] text-slate-500">De <strong className="text-slate-800">{p.de_nom}</strong> · {fmt(p.created_at)}{p.lance_at ? ' · déjà lancée' : ''}</p>
              {p.type === 'modele' && <span className="mt-1 inline-block rounded bg-amber-100 px-1.5 text-[10px] font-semibold text-amber-900" data-testid={`klarys-partage-modele-${p.id}`}>Modèle à compléter</span>}
              <p className="mt-1 text-sm text-slate-900">{p.texte}</p>
              {p.message && <p className="mt-1 rounded bg-slate-50 px-2 py-1 text-xs italic text-slate-600">« {p.message} »</p>}
              <div className="mt-2 flex gap-2">
                <button type="button" onClick={() => lancer(p)} data-testid={`klarys-partage-lancer-${p.id}`}
                  className="inline-flex items-center gap-1 rounded-md bg-[#0a3d62] px-2.5 py-1 text-xs font-semibold text-white hover:bg-[#0c4a77]"><Play className="h-3 w-3" /> {p.type === 'modele' ? 'Remplir et lancer' : 'Lancer avec mes droits'}</button>
                <button type="button" onClick={() => favori(p)} data-testid={`klarys-partage-favori-${p.id}`}
                  className="inline-flex items-center gap-1 rounded-md border border-amber-200 px-2.5 py-1 text-xs text-amber-800 hover:bg-amber-50"><Star className="h-3 w-3" /> {p.type === 'modele' ? 'Ajouter à mes modèles' : 'Favori'}</button>
                <button type="button" onClick={() => supprimer(p)} data-testid={`klarys-partage-supprimer-${p.id}`}
                  className="ml-auto inline-flex items-center gap-1 text-xs text-slate-400 hover:text-rose-600"><Trash2 className="h-3 w-3" /> Retirer</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
